(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('.announcement__message'));
      if (this.messages.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.index = 0;
      const interval = Number(this.dataset.interval) || 4000;
      this.timer = setInterval(() => this.advance(), interval);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    advance() {
      this.messages[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].classList.add('is-active');
    }
  }

  customElements.define('announcement-rotator', AnnouncementRotator);

  const bar = [...document.querySelectorAll('.announcement')].find((item) => getComputedStyle(item).position === 'sticky');
  const syncHeight = () => document.documentElement.style.setProperty('--announcement-h', `${Math.round(bar?.getBoundingClientRect().height || 0)}px`);
  syncHeight();
  if (bar && 'ResizeObserver' in window) new ResizeObserver(syncHeight).observe(bar);
  else window.addEventListener('resize', syncHeight);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buy-box"] && !Shopify.designMode) return;
  try {
    
  /* A plan's refill interval in months, from its option JSON or failing that its name. */
  /* The plan Shopify allocated to this pack, first only; others have no allocation here. */
  function choosePlan(form, variant, plans) {
    let firstFitting = null;

    form.querySelectorAll('[data-plan-cadence]').forEach((option) => {
      const input = option.querySelector('input[name="selling_plan"]');
      const applies = !!input && !!plans[input.value];
      option.hidden = !applies;
      if (!input) return;
      if (!applies) input.checked = false;
      else if (!firstFitting) firstFitting = input;
    });

    const group = form.querySelector('.buybox__purchase');
    if (group) group.hidden = !firstFitting;

    if (!form.dataset.purchase && form.querySelector('.buybox__options')?.dataset.defaultPurchase === 'onetime') {
      form.dataset.purchase = 'onetime';
    }
    const oneTime = form.querySelector('input[name="selling_plan"][value=""]');
    const selectedPlan = form.querySelector('input[name="selling_plan"]:checked');
    const selectedPlanStillFits = !!(selectedPlan?.value && plans[selectedPlan.value]);

    if (form.dataset.purchase === 'onetime' || !firstFitting) {
      if (oneTime) oneTime.checked = true;
    } else if (!selectedPlanStillFits) {
      firstFitting.checked = true;
    }
  }

  /* Keeps the button price in step with the pack and plan. Add to cart works without it. */
  function syncCartPrice(form) {
    const variant = form.querySelector('.buybox__radio:checked');
    if (!variant) return;
    const price = form.querySelector('[data-cart-price]');
    const compare = form.querySelector('[data-cart-compare]');

    let plans = {};
    try {
      plans = JSON.parse(variant.dataset.planData || '{}');
    } catch {}

    /* Resolve the plan before pricing, or the CTA quotes the option that was just replaced. */
    choosePlan(form, variant, plans);

    const plan = form.querySelector('input[name="selling_plan"]:checked');
    let shown = variant.dataset.price || '';
    let struck = variant.dataset.compare || '';

    const chosen = plan && plan.value ? plans[plan.value]?.money : null;
    if (chosen) {
      struck = struck || shown;
      shown = chosen;
    }

    if (price) price.textContent = shown;
    if (compare) compare.textContent = struck;

    /* Each pack quotes its own plan, so every card agrees with the button. */
    const subscribing = !!(plan && plan.value);
    form.querySelectorAll('.buybox__radio').forEach((radio) => {
      const card = form.querySelector(`label[for="${radio.id}"]`);
      if (!card) return;
      let map = {};
      try {
        map = JSON.parse(radio.dataset.planData || '{}');
      } catch {}
      const onPlan = subscribing ? Object.values(map)[0] : null;
      const now = card.querySelector('[data-pack-price]');
      const was = card.querySelector('[data-pack-was]');
      if (now) now.textContent = onPlan?.money || radio.dataset.price || '';
      if (was) was.textContent = onPlan ? radio.dataset.compare || radio.dataset.price || '' : radio.dataset.compare || '';

      const save = card.querySelector('[data-pack-save]');
      if (!save) return;
      const planCents = onPlan?.cents ?? null;
      const paid = Number(planCents ?? radio.dataset.priceCents);
      const before = Number(planCents ? radio.dataset.compareCents || radio.dataset.priceCents : radio.dataset.compareCents);
      const pct = before > paid ? Math.round(((before - paid) / before) * 100) : 0;
      save.textContent = pct ? `Save ${pct}%` : '';
    });
  }

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.buybox__radio, input[name="selling_plan"]');
    if (!input) return;
    const form = input.closest('form');
    if (!form) return;
    /* Remembered so switching pack does not undo a deliberate one-time choice. */
    if (input.name === 'selling_plan') form.dataset.purchase = input.value ? 'sub' : 'onetime';
    syncCartPrice(form);
  });

  /* Plan options ship hidden, so the first pass is what reveals the ones that fit. */
  document.querySelectorAll('.buybox__form').forEach(syncCartPrice);

  /* The sticky bar appears only after its own CTA has left the top of the screen, so it never
     covers the buy box it duplicates. Hidden until observed, so it cannot flash without JS. */
  document.querySelectorAll('.buybox__slide').forEach((slide) => {
    const bar = slide.querySelector('[data-sticky-bar]');
    const cta = slide.querySelector('.buybox__submit');
    if (!bar || !cta || !('IntersectionObserver' in window)) return;

    bar.hidden = false;
    new IntersectionObserver(
      ([entry]) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', scrolledPast);
      },
      { threshold: 0 }
    ).observe(cta);

    /* Lands the CTA on the bottom edge, so the packs and price above it fill the screen.
       The href alone would put the packs at the top and push the CTA off; this corrects that. */
    const jump = bar.querySelector('.buybox__sticky-cta');
    if (!jump) return;
    jump.addEventListener('click', (event) => {
      event.preventDefault();
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      cta.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'end' });
    });
  });

  /* Two shapes over one markup: below 1024px the frames are a swipe rail, above it the radios switch
     a stacked frame and the steppers walk the strip. Either way the current image is the checked
     radio, so both halves read and write the same state. */
  document.querySelectorAll('.buybox__gallery').forEach((gallery) => {
    const stage = gallery.querySelector('.buybox__stage');
    const rail = gallery.querySelector('.buybox__rail');
    const frames = gallery.querySelectorAll('.buybox__frame');
    const radios = gallery.querySelectorAll('.buybox__frame-radio');
    const thumbs = gallery.querySelectorAll('.buybox__thumb');
    const prev = gallery.querySelector('[data-gallery-prev]');
    const next = gallery.querySelector('[data-gallery-next]');
    if (!stage || frames.length < 2) return;

    const swipes = window.matchMedia('(max-width: 1023px)');
    const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pitch = () => frames[0].offsetWidth + (parseFloat(getComputedStyle(stage).columnGap) || 0);
    const chosen = () => Math.max([...radios].findIndex((radio) => radio.checked), 0);

    const sync = () => {
      const shown = swipes.matches ? Math.round(stage.scrollLeft / pitch()) : chosen();
      thumbs.forEach((thumb, index) => {
        if (index === shown) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
      /* Keeps the radios in step, so a swipe survives a rotation into the desktop layout. */
      if (radios[shown]) radios[shown].checked = true;
      if (prev) prev.disabled = shown <= 0;
      if (next) next.disabled = shown >= frames.length - 1;
    };

    /* Centres the thumbnail, so the strip follows the steppers once it is too wide to sit still. */
    const step = (delta) => {
      const shown = Math.min(Math.max(chosen() + delta, 0), frames.length - 1);
      radios[shown].checked = true;
      const thumb = thumbs[shown];
      if (thumb) {
        rail.scrollTo({
          left: thumb.offsetLeft - (rail.clientWidth - thumb.offsetWidth) / 2,
          behavior: still() ? 'auto' : 'smooth',
        });
      }
      sync();
    };

    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    gallery.addEventListener('change', sync);
    stage.addEventListener('scroll', sync, { passive: true });
    swipes.addEventListener('change', sync);
    sync();
  });

  class ProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prev = this.querySelector('[data-carousel-prev]');
      this.next = this.querySelector('[data-carousel-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.prev.addEventListener('click', () => this.scrollBySlide(-1));
      this.next.addEventListener('click', () => this.scrollBySlide(1));
      this.track.addEventListener('scroll', () => this.syncControls(), { passive: true });
      this.syncControls();
    }

    scrollBySlide(direction) {
      const slide = this.track.querySelector('.buybox__slide');
      if (!slide) return;
      this.track.scrollBy({ left: direction * (slide.offsetWidth + this.gap()), behavior: 'smooth' });
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    syncControls() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
    }
  }

  customElements.define('product-carousel', ProductCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* Steps the quantity and submits, so the count is not stranded behind Update cart. */
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('.stepper__input');
    if (!input) return;
    const next = Math.max(0, Number(input.value || 0) + Number(step.dataset.qtyStep));
    if (String(next) === input.value) return;
    input.value = next;
    input.form?.requestSubmit(input.form.querySelector('[name="update"]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Submitting on change keeps sorting to one interaction. The noscript button covers the rest. */
  document.addEventListener('change', (event) => {
    if (event.target.matches('.collection__select')) event.target.form.submit();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  function footerBlockLinkListClickHeading() {
    const footerBlockLinkListHeading = document.querySelectorAll('.footer_menus_wrapper .footer-block__heading');
    footerBlockLinkListHeading.forEach((heading) => {
      heading.addEventListener('click', () => {
        heading.parentElement.classList.toggle('active');
      });
    });
  }
  document.addEventListener('DOMContentLoaded', footerBlockLinkListClickHeading);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legacy-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.resizeTimeout = null;
      this.lastKnownHeight = null;
      this.initialHeightSet = false;

      // CLS Optimization: Set initial height immediately to prevent any shift
      this.setInitialHeaderHeight();

      // CLS Optimization: Use ResizeObserver instead of resize events for better performance
      this.initializeResizeObserver();

      // CLS Optimization: Debounced media query handler
      const debouncedSetHeight = this.debounce(() => {
        this.setHeaderHeight();
      }, 150); // Slightly longer debounce for better performance

      window.matchMedia('(max-width: 990px)').addEventListener('change', debouncedSetHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    // CLS Optimization: Set initial height immediately without measuring
    setInitialHeaderHeight() {
      // Use the CSS-calculated initial height to avoid any layout shift
      const initialHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height-initial').trim();
      this.lastKnownHeight = parseInt(initialHeight);
      this.initialHeightSet = true;
    }

    // CLS Optimization: Initialize ResizeObserver for efficient resize handling
    initializeResizeObserver() {
      if (!window.ResizeObserver) {
        // Fallback for browsers without ResizeObserver support
        window.addEventListener('resize', this.debounce(() => {
          this.setHeaderHeight();
        }, 150));
        return;
      }

      this.resizeObserver = new ResizeObserver(entries => {
        // Use requestAnimationFrame to batch updates
        requestAnimationFrame(() => {
          this.setHeaderHeight();
        });
      });

      // Observe the header for size changes
      this.resizeObserver.observe(this.header);
    }

    setHeaderHeight() {
      // CLS Optimization: Only update if height actually changed to prevent unnecessary reflows
      const currentHeight = this.header.offsetHeight;
      
      // Skip if height hasn't changed significantly (allow 1px tolerance for subpixel rendering)
      if (Math.abs(this.lastKnownHeight - currentHeight) <= 1) {
        return;
      }

      this.lastKnownHeight = currentHeight;
      
      // Use requestAnimationFrame to batch DOM writes and prevent layout thrashing
      requestAnimationFrame(() => {
        // CLS Optimization: Only update if the difference is significant enough to matter
        const currentCSSHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
        if (Math.abs(currentCSSHeight - currentHeight) > 2) {
          document.documentElement.style.setProperty('--header-height', `${currentHeight}px`);
        }
      });
    }

    // CLS Optimization: Debounce utility to prevent excessive function calls
    debounce(func, wait) {
      return (...args) => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      
      // CLS Optimization: Clean up ResizeObserver and timeouts to prevent memory leaks
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
      
      if (this.resizeTimeout) {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = null;
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class MegaMenuHover {
    static CLOSE_DELAY = 80;
    static ANIMATION_MS = 320;

    static init() {
      const hoverMedia = window.matchMedia('(min-width: 990px)');

      const finishClose = (targetDetails) => {
        targetDetails.classList.remove('mega-menu--closing');
        targetDetails.removeAttribute('open');
        const targetSummary = targetDetails.querySelector('summary');
        if (targetSummary) targetSummary.setAttribute('aria-expanded', 'false');
      };

      const closeDetailsAnimated = (targetDetails) => {
        if (!targetDetails.hasAttribute('open')) return;
        if (targetDetails.classList.contains('mega-menu--closing')) return;

        targetDetails.classList.add('mega-menu--closing');
        setTimeout(() => finishClose(targetDetails), MegaMenuHover.ANIMATION_MS);
      };

      const setupMegaMenus = () => {
        document.querySelectorAll('header-menu details.mega-menu').forEach((details) => {
          const headerMenu = details.closest('header-menu');
          if (!headerMenu || headerMenu.dataset.megaHoverInit === 'true') return;

          headerMenu.dataset.megaHoverInit = 'true';
          const summary = details.querySelector('summary');
          const headerWrapper = document.querySelector('.header-wrapper');
          let closeTimeout = null;

          const openMenu = () => {
            if (!hoverMedia.matches) return;

            clearTimeout(closeTimeout);
            details.classList.remove('mega-menu--closing');

            document.querySelectorAll('header-menu details.mega-menu[open]').forEach((openDetails) => {
              if (openDetails !== details) {
                closeDetailsAnimated(openDetails);
              }
            });

            if (!details.hasAttribute('open')) {
              details.setAttribute('open', '');
              if (summary) summary.setAttribute('aria-expanded', 'true');
            }

            if (headerWrapper) {
              headerWrapper.preventHide = true;
              document.documentElement.style.setProperty(
                '--header-bottom-position-desktop',
                `${Math.floor(headerWrapper.getBoundingClientRect().bottom)}px`
              );
            }
          };

          const closeMenu = () => {
            if (!hoverMedia.matches) return;

            clearTimeout(closeTimeout);
            closeTimeout = setTimeout(() => {
              closeDetailsAnimated(details);
              if (headerWrapper) headerWrapper.preventHide = false;
            }, MegaMenuHover.CLOSE_DELAY);
          };

          const onSummaryClick = (event) => {
            if (hoverMedia.matches) event.preventDefault();
          };

          const bindHover = () => {
            headerMenu.addEventListener('mouseenter', openMenu);
            headerMenu.addEventListener('mouseleave', closeMenu);
            if (summary) summary.addEventListener('click', onSummaryClick);
          };

          const unbindHover = () => {
            headerMenu.removeEventListener('mouseenter', openMenu);
            headerMenu.removeEventListener('mouseleave', closeMenu);
            if (summary) summary.removeEventListener('click', onSummaryClick);
            clearTimeout(closeTimeout);
            details.classList.remove('mega-menu--closing');
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          };

          const updateMode = () => {
            unbindHover();
            if (hoverMedia.matches) bindHover();
          };

          updateMode();
          hoverMedia.addEventListener('change', updateMode);
        });
      };

      setupMegaMenus();

      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', setupMegaMenus);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => MegaMenuHover.init());
  } else {
    MegaMenuHover.init();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tp-best-sellers')) {
    customElements.define(
      'tp-best-sellers',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.slides = [...this.track.children];
          if (!this.slides.length) return;
          // Below desktop the rail shows < 5 cards, so skip the equal-height treatment.
          this.mobile = matchMedia('(max-width: 1023px)');

          const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          const move = (dir) => this.track.scrollBy({ left: dir * this.step(), behavior: smooth });
          this.querySelector('[data-prev]').addEventListener('click', () => move(-1));
          this.querySelector('[data-next]').addEventListener('click', () => move(1));

          // Images and fonts change the natural card height, so re-measure after either lands.
          this.track.addEventListener('load', () => this.measure(), true);
          document.fonts?.ready.then(() => this.measure());
          addEventListener('resize', () => this.measure());
          this.measure();
        }

        step() {
          return this.slides[0].getBoundingClientRect().width + 16;
        }

        // Every card takes the tallest natural height (desktop only).
        measure() {
          this.slides.forEach((slide) => (slide.style.height = ''));
          if (this.mobile.matches) return;
          const base = Math.max(...this.slides.map((slide) => slide.offsetHeight));
          if (!base) return; // not laid out yet; the next load or resize re-measures
          this.slides.forEach((slide) => (slide.style.height = `${base}px`));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-cart-drawer"]) return;
  try {
    
  (() => {
    if (window.tpCart) return;
    const html = document.documentElement;
    const drawer = () => document.querySelector('[data-tp-cd]');
    const panel = () => drawer()?.querySelector('.tp-cd__panel');
    const containers = () => [...document.querySelectorAll('[data-tp-cart-section]')];
    const jsUrl = (key) => `${drawer().dataset[key]}.js`;
    const headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    const post = (key, body) => fetch(jsUrl(key), {
      method: 'POST',
      headers: body instanceof FormData ? headers : { ...headers, 'Content-Type': 'application/json' },
      body: body instanceof FormData ? body : JSON.stringify(body),
    });
    let busy = false;
    const getCart = async () => {
      const response = await fetch(`${drawer().dataset.cart}.js`, { headers, cache: 'no-store' });
      if (!response.ok) throw new Error('The cart could not be reached. Please try again.');
      return response.json();
    };

    const bundle = (item) => {
      try { return JSON.parse(item.properties?.__kaching_bundles || 'null'); }
      catch { return null; }
    };
    const bundleKey = (data) => data?.id && data.deal && data.v ? JSON.stringify([data.id, data.deal, data.v]) : null;
    const includedLids = (cart) => {
      const groups = new Set(cart.items.filter((item) => item.handle === 'titanpan-pure-titanium-frying-pan™' && bundle(item)?.main === true)
        .map((item) => bundleKey(bundle(item))).filter(Boolean));
      return cart.items.filter((item) => {
        const data = bundle(item);
        return item.handle === 'precision-fit-glass-lid-hidden-listing' && item.final_line_price === 0 &&
          typeof data?.gift === 'string' && data.gift.length > 0 && groups.has(bundleKey(data));
      });
    };
    const removeIncludedLids = async () => {
      let cart = await getCart();
      const limit = includedLids(cart).length;
      for (let i = 0; i < limit; i += 1) {
        const lid = includedLids(cart)[0];
        if (!lid) break;
        const changed = await post('change', { id: lid.key, quantity: 0 });
        if (!changed.ok) throw new Error('The included lid could not be updated. Please try again.');
        cart = await changed.json();
      }
      if (includedLids(cart).length) throw new Error('The included lid could not be updated. Please try again.');
    };

    /* Re-render cart sections and synchronize the item count. */
    const refresh = async () => {
      const ids = containers().map((el) => el.dataset.tpCartSection);
      if (!ids.length) return;
      const res = await fetch(`${location.pathname}?sections=${encodeURIComponent(ids.join(','))}`);
      const data = await res.json();
      ids.forEach((id) => {
        const el = document.querySelector(`[data-tp-cart-section="${id}"]`);
        const fresh = data[id] && new DOMParser().parseFromString(data[id], 'text/html').querySelector(`[data-tp-cart-section="${id}"]`);
        if (el && fresh) el.replaceWith(fresh);
      });
      window.bucksCC?.reConvert?.();
      const swap = drawer()?.querySelector('[data-tp-cart-section]');
      const count = Number(swap?.dataset.count || 0);
      const icon = document.querySelector('.tp-header__cart');
      if (icon) {
        let badge = icon.querySelector('.tp-header__count');
        if (count > 0 && !badge) {
          badge = document.createElement('span');
          badge.className = 'tp-header__count';
          badge.setAttribute('aria-hidden', 'true');
          icon.append(badge);
        }
        if (badge) count > 0 ? (badge.textContent = count) : badge.remove();
        icon.setAttribute('aria-label', `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
      }
      const subtotal = document.querySelector('[data-tp-subtotal]')?.textContent.trim();
      document.querySelectorAll('[data-tp-cart-status]').forEach((s) => {
        s.textContent = `Cart updated: ${count} ${count === 1 ? 'item' : 'items'}${subtotal ? `, subtotal ${subtotal}` : ''}.`;
      });
      return swap?.dataset.orphan;
    };

    /* Serialize cart changes and restore focus after rendering. */
    const run = async (request, { line, openAfter } = {}) => {
      if (busy) return;
      busy = true;
      const focused = document.activeElement;
      const focusSection = focused?.closest('[data-tp-cart-section]')?.dataset.tpCartSection;
      const focusLabel = focused?.getAttribute('aria-label');
      line?.classList.add('is-busy');
      drawer()?.classList.add('is-busy');
      containers().forEach((el) => {
        el.setAttribute('aria-busy', 'true');
        el.querySelectorAll('button, input, select').forEach((c) => { c.disabled = true; });
      });
      let error = '';
      try {
        const res = await request();
        if (!res.ok) {
          const d = await res.json().catch(() => ({}));
          error = d.description || d.message || 'Something went wrong. Please try again.';
        }
        if (!error) await removeIncludedLids();
      } catch (e) {
        error = e.message || 'The cart could not be reached. Please try again.';
      }
      let orphan;
      try {
        orphan = await refresh();
      } catch (e) {
        location.reload();
        return;
      }
      drawer()?.classList.remove('is-busy');
      busy = false;
      if (error) {
        document.querySelectorAll('[data-tp-cart-error]').forEach((el) => { el.textContent = error; el.hidden = false; });
      }
      const home = focusSection && document.querySelector(`[data-tp-cart-section="${focusSection}"]`);
      if (home) {
        const same = focusLabel && [...home.querySelectorAll('[aria-label]')].find((n) => n.getAttribute('aria-label') === focusLabel);
        (same || home.querySelector('[data-tp-focus-fallback]'))?.focus();
      }
      if (openAfter) open();
      /* Protection on its own is not an order: drop it once the last real line goes. */
      if (orphan) run(() => post('change', { id: orphan, quantity: 0 }));
    };

    const open = () => {
      const d = drawer();
      if (!d || 'cartPage' in d.dataset || d.classList.contains('is-open')) return;
      d.inert = false;
      d.classList.add('is-open');
      html.classList.add('tp-cd-open');
      panel().querySelector('.tp-cd__close').focus({ preventScroll: true });
    };
    const close = () => {
      const d = drawer();
      if (!d || !d.classList.contains('is-open')) return;
      d.classList.remove('is-open');
      d.inert = true;
      html.classList.remove('tp-cd-open');
      document.querySelector('.tp-header__cart')?.focus();
    };

    const onSubmit = (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement) || !(form.getAttribute('action') || '').includes('/cart/add') || !drawer()) return;
      e.preventDefault();
      if (busy) return;
      const btn = e.submitter || form.querySelector('[type="submit"]');
      const wasDisabled = btn?.disabled;
      btn?.setAttribute('aria-busy', 'true');
      if (btn) btn.disabled = true;
      const data = new FormData(form);
      run(() => post('add', data), { openAfter: true }).finally(() => {
        if (!btn) return;
        btn.removeAttribute('aria-busy');
        btn.disabled = wasDisabled;
      });
    };
    document.addEventListener('submit', (e) => { if (!e.target.matches?.('[data-tp-form]')) onSubmit(e); }, true);
    document.addEventListener('submit', (e) => { if (!e.defaultPrevented && e.target.matches?.('[data-tp-form]')) onSubmit(e); });

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const t = e.target;
      if (t.closest('[data-tp-cd-close]')) { e.preventDefault(); close(); return; }
      const qty = t.closest('[data-tp-qty]');
      if (qty && qty.closest('[data-tp-cart-section]') && drawer()) {
        e.preventDefault();
        if (!busy) run(() => post('change', { id: qty.dataset.key, quantity: Number(qty.dataset.tpQty) }), { line: qty.closest('[data-tp-line]') });
        return;
      }
      const icon = t.closest('.tp-header__cart');
      if (icon && drawer() && !('cartPage' in drawer().dataset)) { e.preventDefault(); open(); }
    });

    document.addEventListener('change', (e) => {
      const size = e.target.closest('[data-tp-cart-size]');
      if (size && size.closest('[data-tp-cart-section]') && drawer()) {
        if (busy) return;
        const change = {
          key: size.dataset.key,
          variantId: Number(size.value),
          productId: Number(size.dataset.product),
          optionIndex: Number(size.dataset.optionIndex),
        };
        run(async () => {
          const { replaceCartVariant } = await import(drawer().dataset.variantScript);
          return replaceCartVariant({
            getCart,
            add: (item) => post('add', { items: [item] }),
            change: (key, quantity) => post('change', { id: key, quantity }),
            ...change,
          });
        }, { line: size.closest('[data-tp-line]') });
        return;
      }
      const protect = e.target.closest('[data-tp-protect]');
      if (protect) {
        run(() => (protect.checked
          ? post('add', { items: [{ id: Number(protect.dataset.tpProtect), quantity: 1 }] })
          : post('change', { id: protect.dataset.key, quantity: 0 })));
        return;
      }
      const select = e.target.closest('[data-tp-up-variant]');
      if (select) {
        select.form.querySelector('[data-tp-up-price]').innerHTML = select.selectedOptions[0].dataset.html;
        window.bucksCC?.reConvert?.();
      }
    });

    document.addEventListener('keydown', (e) => {
      const d = drawer();
      if (!d?.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      const f = [...panel().querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')]
        .filter((el) => el.getClientRects().length);
      if (!f.length) return;
      const i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === -1 || i === f.length - 1)) { e.preventDefault(); f[0].focus(); }
    });

    document.addEventListener('shopify:section:select', (e) => { if (e.target.querySelector?.('[data-tp-cd]')) open(); });
    document.addEventListener('shopify:section:deselect', (e) => { if (e.target.querySelector?.('[data-tp-cd]')) close(); });

    window.tpCart = { open, close, refresh };
    if (document.querySelector('[data-tp-with-lid]') && document.querySelector('[data-tp-lid-gift]')) {
      run(() => Promise.resolve({ ok: true }));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-main-article"]) return;
  try {
    
  /* Share: the native share sheet where there is one; otherwise the <details> opens a copy-link popover. */
  if (!customElements.get('tp-share')) {
    customElements.define('tp-share', class extends HTMLElement {
      connectedCallback() {
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        const input = this.querySelector('input');
        const msg = this.querySelector('.tp-art__share-msg');

        summary.addEventListener('click', (event) => {
          if (!navigator.share || details.open) return;
          event.preventDefault();
          navigator.share({ title: document.title, url: input.value }).catch(() => {});
        });

        this.querySelector('.tp-art__share-copy').addEventListener('click', () => {
          const done = () => {
            msg.textContent = this.dataset.copied;
            this.classList.add('is-copied');
          };
          if (navigator.clipboard) {
            navigator.clipboard.writeText(input.value).then(done, () => input.select());
          } else {
            input.select();
          }
        });

        details.addEventListener('toggle', () => {
          if (details.open) return;
          msg.textContent = '';
          this.classList.remove('is-copied');
        });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !details.open) return;
          details.open = false;
          summary.focus();
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-press-quote"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      root.addEventListener('click', (e) => {
        const logo = e.target.closest('.tp-press__logo');
        if (!logo) return;
        const i = logo.dataset.index;
        root.querySelectorAll('.tp-press__logo').forEach((l) => {
          const on = l === logo;
          l.classList.toggle('is-faded', !on);
          l.setAttribute('aria-pressed', on);
        });
        root.querySelectorAll('.tp-press__quote').forEach((q) => { q.hidden = q.dataset.index !== i; });
      });
    }
    const boot = () => document.querySelectorAll('[data-tp-press]').forEach(init);
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-reviews-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const viewport = root.querySelector('[data-viewport]');
      const track = root.querySelector('[data-track]');
      let busy = false;

      const pauseAll = () => root.querySelectorAll('video').forEach((v) => {
        v.pause();
        const wrap = v.closest('.tp-reviews-hero__video');
        wrap.classList.remove('is-playing');
        wrap.querySelector('[data-play]').setAttribute('aria-label', 'Play video review');
      });
      const setCurrent = (el) => {
        [...track.children].forEach((s) => s.classList.toggle('is-current', s === el));
      };

      // Infinite rotation: slide the track one item, then move that item to the other end.
      const go = (dir) => {
        const items = [...track.children];
        if (busy || items.length < 2) return;
        busy = true;
        pauseAll();
        const ms = reduce() ? 0 : 300;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.style.transition = 'none';
        if (dir > 0) {
          setCurrent(items[1]);
          track.style.transition = `transform ${ms}ms ease`;
          track.style.transform = `translateX(${-(items[0].offsetWidth + gap)}px)`;
          setTimeout(() => {
            track.style.transition = 'none';
            track.append(items[0]);
            track.style.transform = '';
            busy = false;
          }, ms);
        } else {
          const last = items[items.length - 1];
          track.prepend(last);
          setCurrent(last);
          track.style.transform = `translateX(${-(last.offsetWidth + gap)}px)`;
          track.offsetWidth;
          track.style.transition = `transform ${ms}ms ease`;
          track.style.transform = '';
          setTimeout(() => { busy = false; }, ms);
        }
      };

      root.querySelector('[data-prev]').addEventListener('click', () => go(-1));
      root.querySelector('[data-next]').addEventListener('click', () => go(1));

      // Swipe
      let x0 = null, y0 = 0, swiped = false;
      viewport.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; swiped = false; });
      viewport.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { swiped = true; go(dx < 0 ? 1 : -1); }
      });
      viewport.addEventListener('click', (e) => { if (swiped) { e.preventDefault(); e.stopPropagation(); swiped = false; } }, true);

      // Click to play / pause. The video element is created on first play so nothing downloads up front.
      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-play]');
        if (!btn) return;
        const wrap = btn.closest('.tp-reviews-hero__video');
        let video = wrap.querySelector('video');
        if (!video) {
          video = document.createElement('video');
          video.src = wrap.dataset.videoSrc;
          video.playsInline = true;
          video.loop = true;
          video.preload = 'auto';
          wrap.prepend(video);
        }
        if (video.paused) {
          pauseAll();
          wrap.classList.add('is-playing');
          btn.setAttribute('aria-label', 'Pause video review');
          video.play().catch(() => { video.muted = true; video.play().catch(() => {}); });
        } else {
          pauseAll();
        }
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (entry.intersectionRatio <= 0.25) pauseAll(); });
        }, { threshold: [0, 0.25, 0.5] }).observe(root);
      }
    }

    const boot = () => document.querySelectorAll('[data-tp-reviews-hero]').forEach(init);
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-reviews-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = () => matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const viewport = root.querySelector('[data-viewport]');
      const track = root.querySelector('[data-track]');
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      let busy = false;

      const visible = () => [...track.children].filter((c) => !c.hidden);

      // Infinite rotation: slide one card, then move it to the other end. Hidden cards ride along unseen.
      const go = (dir) => {
        const items = visible();
        if (busy || items.length < 2) return;
        busy = true;
        const ms = reduce() ? 0 : 300;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.style.transition = 'none';
        if (dir > 0) {
          track.style.transition = `transform ${ms}ms ease`;
          track.style.transform = `translateX(${-(items[0].offsetWidth + gap)}px)`;
          setTimeout(() => {
            track.style.transition = 'none';
            track.append(items[0]);
            track.style.transform = '';
            busy = false;
          }, ms);
        } else {
          const last = items[items.length - 1];
          track.prepend(last);
          track.style.transform = `translateX(${-(last.offsetWidth + gap)}px)`;
          track.offsetWidth;
          track.style.transition = `transform ${ms}ms ease`;
          track.style.transform = '';
          setTimeout(() => { busy = false; }, ms);
        }
      };

      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
        });
        viewport.setAttribute('aria-labelledby', tab.id);
        [...track.children].forEach((c) => { c.hidden = !!c.dataset.tab && c.dataset.tab !== tab.dataset.tab; });
        track.style.transition = 'none';
        track.style.transform = '';
        const many = visible().length > 1;
        prev.disabled = next.disabled = !many;
      };

      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (!step) return;
          const target = tabs[(i + step + tabs.length) % tabs.length];
          target.focus();
          select(target);
        });
      });
      const current = tabs.find((t) => t.getAttribute('aria-selected') === 'true');
      if (current) select(current);

      prev.addEventListener('click', () => go(-1));
      next.addEventListener('click', () => go(1));

      let x0 = null, y0 = 0;
      viewport.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; });
      viewport.addEventListener('pointerup', (e) => {
        if (x0 === null) return;
        const dx = e.clientX - x0, dy = e.clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      });
    }

    const boot = () => document.querySelectorAll('[data-tp-reviews-tabs]').forEach(init);
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-story-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const track = root.querySelector('[data-track]');
      const slides = [...root.querySelectorAll('[data-slide]')];
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      const fill = root.querySelector('[data-fill]');
      const dots = [...root.querySelectorAll('.tp-story__dots li')];
      if (slides.length < 2) return;
      let index = 0;

      const go = (i) => {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.style.transform = `translateX(${-index * 100}%)`;
        slides.forEach((s, n) => { s.inert = n !== index; });
        fill.style.width = `${(index / (slides.length - 1)) * 100}%`;
        dots.forEach((d, n) => d.classList.toggle('is-filled', n <= index));
        prev.disabled = index === 0;
        next.disabled = index === slides.length - 1;
      };
      go(0);
      root._tpStoryGo = go;

      prev.addEventListener('click', () => go(index - 1));
      next.addEventListener('click', () => go(index + 1));
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') go(index - 1);
        else if (e.key === 'ArrowRight') go(index + 1);
      });

      // ponytail: threshold swipe, no drag-follow; add live dragging if the snap feels abrupt on touch.
      let startX = null;
      let startY = 0;
      const viewport = root.querySelector('[data-viewport]');
      viewport.addEventListener('pointerdown', (e) => { startX = e.clientX; startY = e.clientY; });
      viewport.addEventListener('pointerup', (e) => {
        if (startX === null) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(index + (dx < 0 ? 1 : -1));
      });
      viewport.addEventListener('pointercancel', () => { startX = null; });
      viewport.addEventListener('dragstart', (e) => e.preventDefault());
    }

    const initAll = () => document.querySelectorAll('[data-tp-story]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', (e) => {
      const slide = e.target.closest('[data-slide]');
      const root = e.target.closest('[data-tp-story]');
      if (!slide || !root || !root._tpStoryGo) return;
      root._tpStoryGo([...root.querySelectorAll('[data-slide]')].indexOf(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tp-trusted-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      const videos = [...root.querySelectorAll('video[data-src]')];
      const load = (v) => {
        if (v.src) return;
        if (!v.poster) v.preload = 'metadata';
        v.src = v.dataset.src;
      };
      const pause = (v) => {
        v.pause();
        const media = v.parentElement;
        media.classList.remove('is-playing', 'is-loading');
        media.querySelector('[data-play]').setAttribute('aria-pressed', 'false');
      };
      const pauseAll = () => videos.forEach((v) => { if (!v.paused) pause(v); });

      videos.forEach((v) => {
        const media = v.parentElement;
        v.addEventListener('waiting', () => media.classList.add('is-loading'));
        v.addEventListener('playing', () => media.classList.remove('is-loading'));
      });

      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-play]');
        if (!btn) return;
        const media = btn.parentElement;
        const v = media.querySelector('video');
        if (!v.paused) { pause(v); return; }
        pauseAll();
        load(v);
        v.muted = false;
        media.classList.add('is-playing', 'is-loading');
        btn.setAttribute('aria-pressed', 'true');
        v.play().then(() => media.classList.remove('is-loading')).catch(() => {
          v.muted = true;
          v.play().catch(() => media.classList.remove('is-playing', 'is-loading'));
        });
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
          if (entry.isIntersecting) load(entry.target);
          else if (!entry.target.paused) pause(entry.target);
        }), { rootMargin: '200px', threshold: 0.01 });
        videos.forEach((v) => io.observe(v));
      } else {
        videos.forEach(load);
      }
      document.addEventListener('visibilitychange', () => { if (document.hidden) pauseAll(); });
    }

    const boot = () => document.querySelectorAll('[data-tp-trusted]').forEach(init);
    boot();
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
